import { Programs } from "../../models/programsConfig";
import { AaaGameConceptDataSet, AAAGameConceptsQuery } from "../../server/crm/api/models/forms";
import { PaginatedConceptData } from "../../server/crm/api/responses/getFullPaginatedConceptsResponse";
import { ProgramsScope } from "../scopes";
import { createOnboardingAction, createOnboardingAsyncAction } from "./helpers/actionCreators";

export enum AaaGameConceptsActions {
  GET_GAME_CONCEPT_LIST = "@aaaGameConcepts/GET_GAME_CONCEPT_LIST",
  CLEAR_GAME_CONCEPT_QUERY = "@aaaGameConcepts/CLEAR_GAME_CONCEPT_QUERY",
  AAA_UPDATE_GAME_CONCEPT_LIST_START = "@aaaGameConcepts/AAA_UPDATE_GAME_CONCEPT_LIST_START",
  AAA_UPDATE_GAME_CONCEPT_LIST_COMPLETED = "@aaaGameConcepts/AAA_UPDATE_GAME_CONCEPT_LIST_COMPLETED",
  AAA_UPDATE_GAME_CONCEPT_LIST_ERROR = "@aaaGameConcepts/AAA_UPDATE_GAME_CONCEPT_LIST_ERROR",
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const aaaGameConceptsActions: any = {
  aaaGetConcepts: createOnboardingAsyncAction(
    ProgramsScope,
    AaaGameConceptsActions.AAA_UPDATE_GAME_CONCEPT_LIST_START,
    (query: PaginatedConceptData) => ({ query }),
    AaaGameConceptsActions.AAA_UPDATE_GAME_CONCEPT_LIST_COMPLETED,
    (data: AaaGameConceptDataSet) => ({
      data,
    }),
    AaaGameConceptsActions.AAA_UPDATE_GAME_CONCEPT_LIST_ERROR,
    (error: Error) => ({ error })
  ),
  updateConceptsList: createOnboardingAction(
    AaaGameConceptsActions.GET_GAME_CONCEPT_LIST,
    ProgramsScope,
    (
      conceptsList: AaaGameConceptDataSet,
      program: Programs,
      conceptsListQuery: AAAGameConceptsQuery
    ) => ({
      conceptsList,
      program,
      conceptsListQuery,
    })
  ),
  clearGameConceptListQuery: createOnboardingAction(
    AaaGameConceptsActions.CLEAR_GAME_CONCEPT_QUERY,
    ProgramsScope,
    (program: Programs) => ({ program })
  ),
};
